import axios from 'axios'
import authService from '@/api/authService'

const cache = new Map()
const apiUrl = process.env.VUE_APP_API_URL
const axiosInstance = axios.create({
  baseURL: apiUrl
})

axiosInstance.defaults.withCredentials = true

function getCacheKey (config) {
  const url = config.url.replace(config.baseURL, '')
  return JSON.stringify({
    url,
    body: config.data,
    params: config.params
  })
}

axiosInstance.interceptors.request.use(function (config) {
  if (config.headers.allowRequestDuplication) {
    delete config.headers.allowRequestDuplication
  } else {
    const key = getCacheKey(config)
    if (cache.has(key)) {
      cache.get(key).abort()
    }
    const controler = new AbortController()
    cache.set(key, controler)
    config.signal = controler.signal
  }
  return config
})

axiosInstance.interceptors.response.use(
  response => {
    cache.delete(getCacheKey(response.config))
    return response
  },
  error => {
    const isCancel = axios.isCancel(error)
    if (isCancel) {
      return Promise.reject(new Error(`Canceled duplicated request: ${getCacheKey(error.config)}`))
    }

    if (error.response) {
      const statusCode = error.response.status
      const badStatusCode = (statusCode === 401 || statusCode === 403)
      const isLoginURL = error.response.config.url.indexOf('/auth/token') !== -1

      if (badStatusCode && !isLoginURL) {
        authService.logout()
      }
    }

    return Promise.reject(error)
  }
)

export function clearRequests () {
  for (const controller of cache.values()) {
    controller.abort()
  }
  cache.clear()
}

export function setToken (token) {
  axiosInstance.defaults.headers['Authorization'] = `Bearer ${token}`
}

export default axiosInstance
